import React from 'react';
import {
    main,
    AsiaRick01,
    AsiaRick02,
    AsiaRick03,
    AsiaRick04,
    AsiaRick05,
    AsiaRick06,
    AsiaRick07,
    AsiaRick08,
    AsiaRick09,
    AsiaRick10,
    AsiaRick11,
    AsiaRick12,
    AsiaRick13,
    AsiaRick14,
    AsiaRick15,
    AsiaRick16,
    AsiaRick17,
    AsiaRick18,
    AsiaRick19,
    AsiaRick20,
    AsiaRick21,
    AsiaRick22,
    AsiaRick23,
    AsiaRick24,
    AsiaRick25,
    AsiaRick26,
    AsiaRick27,
    AsiaRick28,
    AsiaRick29,
    AsiaRick30,
    AsiaRick31,
    AsiaRick32,
    AsiaRick33,
    AsiaRick34,
    AsiaRick35,
    AsiaRick36,
    AsiaRick37,
    AsiaRick38
} from '../OurCouplesPics/JoannaRick';

export const JoannaAndRick = {
    bgColor: "bgMint",
    title: "Joanna i Rick – eleganckie wesele w Reducie Banku Polskiego",
    path: "eleganckie-wesele-w-reducie-banku-polskiego",
    minHeight: true,
    seoTitle: "Joanna i Rick – eleganckie wesele w Reducie Banku Polskiego",
    seoText: "Eleganckie wnętrza Reduty Banku Polskiego, turkusowe akcenty i historia pełna emocji – tak wyglądał dzień Joanny i Ricka.",
    mainPic: {
        src: main
    },
    details: "Eleganckie wnętrza Reduty Banku Polskiego, turkusowe akcenty i historia pełna emocji – tak wyglądał dzień Joanny i Ricka. Subtelny blask, muzyka i bliscy stworzyli niezapomniane miejskie wesele w sercu Warszawy.",
    org: "Agencja Ślubna Czary Marry",
    orgLink: "",
    place: "Reduta Banku Polskiego",
    placeLink: "https://www.instagram.com/reduta_banku_polskiego",
    photo: "Nikola Baron",
    photoLink: "https://www.instagram.com/nikolabaron",
    decor: "Love & Flowers",
    decorLink: "https://www.instagram.com/loveandflowers_pracownia",
    movie: "Black Heart Studio",
    movieLink: "https://www.instagram.com/blackheartfilmpl",
    makeup: "Czysty Makeup by Kasia Kot",
    makeupLink: "https://www.instagram.com/czystymakeup",
    hair: "Marlena Burakowska",
    hairLink: "https://www.instagram.com/marlenaburakowska.hair/",
    date: "22 gru 2025",
    textMain:
        <>
            Joanna i Rick to para, która od pierwszego spotkania urzeka spokojem, klasą i autentycznością. Perfekcjoniści z wyczuciem stylu, którzy wiedzieli, czego chcą, ale potrafili też zaufać - słuchać, inspirować się i współtworzyć. Dla nich wesele miało być połączeniem elegancji i emocji, klasyki w nowoczesnym wydaniu, miejsca z historią i ciepłem, które czują bliscy. Choć na co dzień mieszkają za granicą, chcieli, by ten dzień odbył się w Polsce, w sercu Warszawy, mieście z duszą i charakterem. To miało być wielkomiejskie wesele z romantycznym tonem i perfekcyjnym rytmem.
        </>,
    topPic: { src: main },
    content: [
        {
            headerSmall: 'Reduta Banku Polskiego – historia, styl i serce miasta',
            headerClassName: "mint",
            text: "Jeszcze zanim zaczęliśmy wspólne poszukiwania, Asia i Rick wspomnieli o Reducie Banku Polskiego. Zobaczyli zdjęcia tej przestrzeni i od razu poczuli, że to ich miejsce. Po kilku rozmowach i odwiedzinach w innych lokalizacjach decyzja była oczywista - Reduta ma w sobie historię, klasę i niepowtarzalny klimat. Monumentalne kolumny, surowe ściany i eleganckie światło tworzą wyjątkową przestrzeń, w której każda dekoracja ma znaczenie. To wnętrze, które nie potrzebuje nadmiaru - wystarczy subtelny dotyk, by wydobyć jego piękno.",
            pics: [
                { src: AsiaRick01 },
                { src: AsiaRick02 },
                { src: AsiaRick03 },
            ]
        },
        {
            headerSmall: "Przygotowania i first look",
            headerClassName: "mint",
            text: "Dzień rozpoczął się spokojnie w hotelu PURO, gdzie para spędziła poranek w otoczeniu przyjaciół i najbliższych. Nie było pośpiechu, tylko spokój i radość z tego, co nadchodzi. „First look”, moment, w którym Asia i Rick zobaczyli się po raz pierwszy w pełnych stylizacjach, był jednym z najpiękniejszych fragmentów dnia. Krótka cisza, spojrzenie, uśmiech - w tym jednym momencie zmieściło się wszystko. W eleganckich wnętrzach hotelu odbyła się też ich krótka sesja zdjęciowa. Joanna w dopasowanej, minimalistycznej sukni wyglądała olśniewająco – klasycznie, ale z nutą nowoczesności. Rick w idealnie skrojonym garniturze dopełniał całości – razem tworzyli obraz ponadczasowej elegancji.",
            pics: [
                { scr: AsiaRick04 },
                { src: AsiaRick05 },
                { src: AsiaRick06 },
                { src: AsiaRick07 },
                { src: AsiaRick08 },
                { src: AsiaRick09 },
                { src: AsiaRick10 },
                { src: AsiaRick11 },
                { src: AsiaRick12 },
                { src: AsiaRick13 },
                { src: AsiaRick14 },
                { src: AsiaRick15 },
                { src: AsiaRick16 },
                { src: AsiaRick17 }
            ]
        },
        {
            headerSmall: "Ślub w Pałacu Ślubów",
            headerClassName: "mint",
            text: "Ceremonia odbyła się w Pałacu Ślubów na Placu Zamkowym  jednym z najbardziej oczywistych miejsc na ślub w Warszawie, a jednocześnie wyjątkowym. Pierwotnie planowaliśmy wspólny spacer z hotelu do Pałacu – orszak gości, rozmowy, emocje i miasto w tle. Pogoda spłatała jednak figla – deszcz sprawił, że część gości wybrała taksówki. Ale nawet to nie odebrało uroku tej chwili - kilku gości z parasolkami w dłoniach przeszło z uśmiechem przez Stare Miasto, a całość miała wręcz filmowy charakter. Ceremonia była klasyczna i elegancka, z muzyką na żywo, pianinem i skrzypcami, które wypełniły przestrzeń ciepłym dźwiękiem. Para weszła razem, trzymając się za ręce, w towarzystwie swoich świadków. To był moment pełen spokoju, wzruszenia i prostoty, bez zbędnego patosu, za to z ogromną prawdą.",
            pics: [
                { src: AsiaRick18 },
                { src: AsiaRick19 },
                { src: AsiaRick20 },
                { src: AsiaRick21 },
                { src: AsiaRick22 },
                { src: AsiaRick23 },
            ]
        },
        {
            headerSmall: "Dekoracje - tkaniny, światło i symbolika",
            headerClassName: "mint",
            text: "Reduta Banku Polskiego to przestrzeń z charakterem, która sama w sobie jest dekoracją. Naszym celem było tylko delikatnie podkreślić jej piękno i dodać lekkości. Pod sufitem zawisły kremowe tkaniny, miękko spływające na ściany, wplecione z setkami drobnych lampek, które po zmroku stworzyły efekt miękkiego, ciepłego światła. Stoły przykryto długimi, lejącymi się obrusami, które opadały aż do podłogi. Kompozycje z białych kwiatów i świec odbijały światło i podkreślały architekturę wnętrza. Subtelnym, ale niezwykle ważnym elementem był turkus – kolor ich zaręczyn. Rick oświadczył się Asi nad jeziorem o intensywnie turkusowej wodzie, a pierścionek z kamieniem w tym odcieniu stał się punktem wyjścia dla motywu całego wesela. Ten kolor przewijał się w detalach - od świec po wstążki przy winietkach – dodając aranżacji osobistego znaczenia i elegancji z nutą emocji.",
            pics: [
                { src: AsiaRick24 },
                { src: AsiaRick25 },
                { src: AsiaRick26 },
                { src: AsiaRick27 },
                { src: AsiaRick28 },
                { src: AsiaRick29 },
                { src: AsiaRick30 },
            ]
        },
        {
            headerSmall: "Wesele pełne emocji i ciepła",
            headerClassName: "mint",
            text: "Po ceremonii goście wrócili do Reduty, gdzie czekał na nich koktajl i kolacja. Już od pierwszych chwil dało się wyczuć atmosferę bliskości i radości. Rick rozpoczął wieczór przemową – szczerym, pełnym humoru i wzruszeń podziękowaniem dla gości i swojej żony. Zaraz po nim jego świadek dodał kilka słów, które rozbawiły wszystkich do łez. Pierwszy taniec Asi i Ricka był dopracowany, ale pełen lekkości. Po nim parkiet natychmiast wypełnił się gośćmi i już do końca nocy nie opustoszał. DJ Marcin stworzył idealny balans między eleganckim brzmieniem a energią tanecznych rytmów. W przerwach goście mogli odpocząć w strefie chilloutu, przy winie, rozmowach i serach sprowadzonych z Holandii, starannie wybranych przez Ricka jako smak jego rodzinnych stron. To było wesele z klasą, ale i sercem. Pełne śmiechu, emocji i rozmów, w których każdy czuł się częścią tej historii.",
            pics: [
                { src: AsiaRick31 },
                { src: AsiaRick32 },
                { src: AsiaRick33 },
                { src: AsiaRick34 },
                { src: AsiaRick35 },
                { src: AsiaRick36 },
                { src: AsiaRick37 },
                { src: AsiaRick38 },
            ]
        },
        {
            headerSmall: "Nasza rola",
            headerClassName: "mint",
            text: "Dla nas współpraca z Asią i Rickiem była czystą przyjemnością. Od początku wiedzieli, czego chcą, ale z otwartością przyjmowali nasze propozycje. Razem stworzyliśmy dzień, w którym nowoczesność spotkała się z tradycją, a elegancja z emocjami. Wesele w Reducie Banku Polskiego było jak oni – dopracowane, stylowe i pełne znaczeń. Każdy detal miał sens, a każda chwila – emocje, które zostaną z nimi na długo.",
        },
    ],
}